import React, { Component } from 'react'
import { Select, Collapse, Button, Icon, Checkbox } from 'antd'
import { siteContent, subscriptions, services } from '@services/api'

export default class extends Component {
    state = {
        fields: {
            child: 0,
            partner: 0,
            parent: 0,
            price: 0,
            type: 'PERSONAL',
            iteration_type: 'ONCE',
            min_age: 0,
            max_age: 100,
            description: {},
            quantity: null,
            sku: { letter: '', digit: '000' }
        },
        servicesArr: []
    }

    componentDidMount() {
        let description = {}
        siteContent
            .getSiteLngs()
            .then(res => res.data.map(item => (description[item.lng] = { name: '', desc: '' })))
            .then(() => this.setState({ fields: { ...this.state.fields, description } }))
            .catch(err => console.log({ err }))
        services.servicesList().then(res =>
            this.setState({
                servicesArr: res.data.map(ser => {
                    const { id, name } = ser
                    return { id, name, price: 0 }
                })
            })
        )
    }

    componentDidUpdate(prevProps, prevState) {
        const { type } = this.state.fields
        let withAgentCheck = type == 'AGENT' ? null : 0
        prevState.fields.type != type &&
            this.setState({
                fields: {
                    ...this.state.fields,
                    child: withAgentCheck,
                    partner: withAgentCheck,
                    parent: withAgentCheck,
                    quantity: type == 'AGENT' ? 0 : null,
                    iteration_type: 'ONCE'
                }
            })
    }

    render() {
        const { refreshSubs } = this.props
        const { fields, servicesArr } = this.state
        const {
            child,
            partner,
            parent,
            price,
            type,
            iteration_type,
            min_age,
            max_age,
            description,
            quantity,
            sku
        } = fields
        const { Panel } = Collapse
        let spanStyle = { marginTop: 7.5, marginRight: 7.5 }
        return (
            <div style={{ flexDirection: 'column', display: 'flex', position: 'relative' }}>
                <div style={{ flexDirection: 'row', display: 'flex', position: 'relative' }}>
                    <div style={{ flexDirection: 'column', display: 'flex', position: 'relative' }}>
                        טקסט באתר לפי שפות:
                        <Collapse style={{ marginRight: 5, flexDirection: 'column', width: 250 }}>
                            {Object.entries(description).map(([key, value]) => (
                                <Panel header={`${key}`} key={key}>
                                    {Object.entries(value).map(([title, text]) => (
                                        <span key={`${key}${title}`}>
                                            {title == 'name' ? 'כותרת' : 'תיאור'}
                                            <input
                                                style={{ marginRight: 5, width: 225 }}
                                                value={text}
                                                onChange={e =>
                                                    this.setState({
                                                        fields: {
                                                            ...fields,
                                                            description: {
                                                                ...description,
                                                                [key]: {
                                                                    ...value,
                                                                    [title]: e.target.value
                                                                }
                                                            }
                                                        }
                                                    })
                                                }
                                            />
                                        </span>
                                    ))}
                                </Panel>
                            ))}
                        </Collapse>
                    </div>
                    <span style={{ marginTop: 13.5, marginRight: 15.5 }}>
                        מחיר:
                        <input
                            style={{ marginRight: 8, width: 50, marginTop: 14 }}
                            value={price}
                            onChange={e => this.setState({ fields: { ...fields, price: e.target.value } })}
                        />
                    </span>
                    <span style={{ marginTop: 13.5, marginRight: 15.5 }}>
                        מק"ט:
                        <span dir="ltr">
                            <input
                                style={{ marginRight: 8, width: 20, marginTop: 14 }}
                                value={sku.letter}
                                onChange={e =>
                                    this.setState({
                                        fields: {
                                            ...fields,
                                            sku: { ...sku, letter: e.target.value[e.target.value.length - 1] }
                                        }
                                    })
                                }
                            />
                            -
                            <input
                                style={{ marginRight: 8, width: 40, marginTop: 14 }}
                                value={sku.digit}
                                onChange={e =>
                                    this.setState({ fields: { ...fields, sku: { ...sku, digit: e.target.value } } })
                                }
                            />
                        </span>
                    </span>
                </div>
                <div
                    style={{
                        flexDirection: 'row',
                        display: 'flex',
                        position: 'relative',
                        marginTop: 7.5
                    }}
                >
                    <Select
                        value={type}
                        onChange={type => this.setState({ fields: { ...fields, type } })}
                        style={{ width: 250, marginTop: 7.5 }}
                    >
                        <Select.Option value={'PERSONAL'} key={'PERSONAL'}>
                            אישי
                        </Select.Option>
                        <Select.Option value={'COUPLE'} key={'COUPLE'}>
                            זוגי
                        </Select.Option>
                        <Select.Option value={'FAMILY'} key={'FAMILY'}>
                            משפחתי
                        </Select.Option>
                        <Select.Option value={'COUPLE_OLD'} key={'COUPLE_OLD'}>
                            זוגי - גיל הזהב
                        </Select.Option>
                        <Select.Option value={'AGENT'} key={'AGENT'}>
                            סוכן
                        </Select.Option>
                        <Select.Option value={'PERSONAL_PLUS'} key={'PERSONAL_PLUS'}>
                            אישי - פלוס
                        </Select.Option>
                        <Select.Option value={'COUPLE_PLUS'} key={'COUPLE_PLUS'}>
                            זוגי - פלוס
                        </Select.Option>
                        <Select.Option value={'FAMILY_PLUS'} key={'FAMILY_PLUS'}>
                            משפחתי - פלוס
                        </Select.Option>
                        <Select.Option value={'COUPLE_OLD_PLUS'} key={'COUPLE_OLD_PLUS'}>
                            זוגי - גיל הזהב - פלוס
                        </Select.Option>
                        <Select.Option value={'PERSONAL_OLD'} key={'PERSONAL_OLD'}>
                            אישי - גיל הזהב
                        </Select.Option>
                    </Select>
                    {type == 'AGENT' ? (
                        ''
                    ) : (
                        <Select
                            value={iteration_type}
                            onChange={iteration_type => this.setState({ fields: { ...fields, iteration_type } })}
                            style={{ width: 250, ...spanStyle }}
                        >
                            {/* <Select.Option value={null} key={null}>
                                יומי
                            </Select.Option> */}
                            <Select.Option value={'MONTHLY'} key={'MONTHLY'}>
                                חודשי
                            </Select.Option>
                            <Select.Option value={'ONCE'} key={'ONCE'}>
                                תשלום חד פעמי
                            </Select.Option>
                        </Select>
                    )}
                </div>
                {type == 'AGENT' ? (
                    <span style={{ marginTop: 7.5 }}>
                        הגבלת קליינטים:
                        <input
                            style={{ marginRight: 5, width: 30 }}
                            value={quantity}
                            onChange={e => this.setState({ fields: { ...fields, quantity: e.target.value } })}
                        />
                    </span>
                ) : (
                    <div
                        style={{
                            flexDirection: 'row',
                            display: 'flex',
                            position: 'relative',
                            marginTop: 7.5
                        }}
                    >
                        <span style={{ marginTop: 7.5 }}>
                            ילדים כלולים:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={child}
                                onChange={e => this.setState({ fields: { ...fields, child: e.target.value } })}
                            />
                        </span>
                        <span style={spanStyle}>
                            בן זוג כלול:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={partner}
                                onChange={e => this.setState({ fields: { ...fields, partner: e.target.value } })}
                            />
                        </span>
                        <span style={spanStyle}>
                            הורים כלולים:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={parent}
                                onChange={e => this.setState({ fields: { ...fields, parent: e.target.value } })}
                            />
                        </span>
                        <span style={spanStyle}>
                            גיל מינימלי:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={+min_age}
                                onChange={e => this.setState({ fields: { ...fields, min_age: e.target.value } })}
                            />
                        </span>
                        <span style={spanStyle}>
                            גיל מקסימלי:
                            <input
                                style={{ marginRight: 5, width: 30 }}
                                value={+max_age}
                                onChange={e => this.setState({ fields: { ...fields, max_age: e.target.value } })}
                            />
                        </span>
                    </div>
                )}

                {type != 'AGENT' ? (
                    <>
                        <h6 style={{ marginTop: 25 }}> תמחר שירותים עבור המסלול:</h6>
                        {servicesArr.map(ser => (
                            <span
                                key={ser.id}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '45%',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Checkbox
                                    checked={ser.price !== null}
                                    onChange={() =>
                                        this.setState(prev => ({
                                            servicesArr: prev.servicesArr.map(service =>
                                                ser.name == service.name
                                                    ? { ...ser, price: ser.price !== null ? null : 0 }
                                                    : service
                                            )
                                        }))
                                    }
                                />
                                {ser.name} -
                                <input
                                    disabled={ser.price === null}
                                    style={{ width: 45, textAlign: 'center' }}
                                    value={ser.price || 0}
                                    type="number"
                                    onChange={e => {
                                        let price = e.target.value
                                        this.setState(prev => ({
                                            servicesArr: prev.servicesArr.map(item =>
                                                item.id == ser.id ? { ...item, price } : item
                                            )
                                        }))
                                    }}
                                />
                            </span>
                        ))}
                    </>
                ) : (
                    ''
                )}
                <div style={{ flexDirection: 'row', display: 'flex', position: 'relative' }}>
                    <Button
                        style={{ marginTop: 35.5, marginRight: 7.5, width: 225 }}
                        onClick={() =>
                            subscriptions
                                .addSub({
                                    fields: {
                                        ...fields,
                                        sku: `${fields.sku.letter}-${fields.sku.digit}`
                                    },
                                    servicesArr
                                })
                                .then(() => {
                                    alert('מסלול נוסף בהצלחה!')
                                    refreshSubs()
                                })
                                .catch(err => {
                                    console.log({ err })
                                    alert('שגיאה בהוספת מסלול')
                                })
                        }
                    >
                        שמור שינויים <Icon type="check" />
                    </Button>
                </div>
            </div>
        )
    }
}
